<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      custom-class="domain-expired-dialog"
      append-to-body
      title="公告"
    >
      <div class="domain-expired-content">
        <div class="title">此域名已失效，请使用有界AI系统进行登录</div>
        <div class="link" @click="handleJump">
          点击跳转到新域名（记得收藏）>>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DomainExpired',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handleJump() {
      window.location.href = 'https://www.youjiexian.com'
    }
  }
}
</script>

<style lang="scss">
.domain-expired-dialog {
  border-radius: 12px;
  overflow: hidden;
  
  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: none;
    .el-dialog__title {
      font-size: 24px;
      font-weight: 600;
      color: #000;
      line-height: 1.5;
    }
    .el-dialog__headerbtn {
      top: 24px;
      right: 24px;
      font-size: 20px;
    }
  }
  
  .el-dialog__body {
    padding: 24px;
    padding-top: 10px;
  }
}
</style>

<style scoped lang="scss">
.domain-expired-content {
  background: #fff;
  padding: 10px 20px 40px;
  
  .title {
    font-size: 20px;
    color: #333;
    margin-bottom: 30px;
    line-height: 1.6;
    text-align: center;
    font-weight: 500;
  }
  
  .link {
    font-size: 18px;
    color: #8358FF;
    padding: 18px 20px;
    cursor: pointer;
    font-weight: 500;
    text-align: center;
    transition: all 0.3s ease;
  }
}
</style>
